// Animácie príchodu (data-reveal) a parallax obrázkov (data-parallax) – pozri _reveal.scss
const REDUCED_MOTION = window.matchMedia( "(prefers-reduced-motion: reduce)" ).matches

function initReveal() {
    const root = document.documentElement
    root.classList.add( "js-reveal" )

    // položky v stagger skupinách bez vlastného atribútu (napr. CF7 polia)
    document.querySelectorAll( "[data-reveal-stagger][data-reveal-items]" ).forEach( function( group ) {
        group.querySelectorAll( group.dataset.revealItems ).forEach( function( item ) {
            if ( !item.hasAttribute( "data-reveal" ) ) item.setAttribute( "data-reveal", "up" )
        })
    })

    // stagger: oneskorenie podľa poradia v skupine
    document.querySelectorAll( "[data-reveal-stagger]" ).forEach( function( group ) {
        const step = parseFloat( group.dataset.revealStagger ) || 0.1
        const base = parseFloat( group.style.getPropertyValue( "--reveal-delay" ) ) || 0

        group.querySelectorAll( "[data-reveal]" ).forEach( function( item, i ) {
            item.style.setProperty( "--reveal-delay", ( base + i * step ).toFixed( 2 ) + "s" )
        })
    })

    const targets = document.querySelectorAll( "[data-reveal]" )

    if ( REDUCED_MOTION || !( "IntersectionObserver" in window ) ) {
        targets.forEach( function( el ) { el.classList.add( "is-revealed" ) })
        return
    }

    const observer = new IntersectionObserver( function( entries ) {
        entries.forEach( function( entry ) {
            if ( entry.isIntersecting ) {
                entry.target.classList.add( "is-revealed" )
                observer.unobserve( entry.target )
            }
        })
    // threshold 0: clip varianty majú v skrytom stave nulovú plochu, vyšší threshold by sa nikdy nesplnil
    }, { threshold: 0, rootMargin: "0px 0px -12% 0px" })

    targets.forEach( function( el ) { observer.observe( el ) })
}

function initParallax() {
    const items = Array.prototype.map.call( document.querySelectorAll( "[data-parallax]" ), function( el ) {
        return { el: el, speed: parseFloat( el.dataset.parallax ) || 0.15 }
    })

    if ( !items.length || REDUCED_MOTION ) return

    items.forEach( function( item ) {
        // scale dáva obrázku rezervu presne na rozsah posunu
        item.el.style.setProperty( "--parallax-scale", ( 1 + item.speed * 2 ).toFixed( 3 ) )
    })

    let ticking = false

    function update() {
        const vh = window.innerHeight

        items.forEach( function( item ) {
            const rect = item.el.getBoundingClientRect()

            if ( rect.bottom < 0 || rect.top > vh ) return

            // -1 (element dole pod viewportom) … 0 (v strede) … 1 (hore nad viewportom)
            const progress = ( vh / 2 - ( rect.top + rect.height / 2 ) ) / vh
            item.el.style.setProperty( "--parallax-y", ( progress * item.speed * rect.height ).toFixed( 1 ) + "px" )
        })

        ticking = false
    }

    function requestUpdate() {
        if ( !ticking ) {
            window.requestAnimationFrame( update )
            ticking = true
        }
    }

    window.addEventListener( "scroll", requestUpdate, { passive: true })
    window.addEventListener( "resize", requestUpdate )
    update()
}

$(document).ready( function() {
    initReveal()
    initParallax()
})
